import React, { Component } from 'react';

class Cliente extends Component {
    render() {

        let classImg = this.props.showBorder ? "g-brd-left g-brd-bottom g-brd-gray-light-v4 g-py-40" : "g-brd-left g-brd-gray-light-v4 g-py-40";

        return (
            <div className="col-md-3 px-0">
                <div className={classImg}>
                    <img className="img-fluid g-width-180 g-opacity-0_8 g-opacity-1--hover g-transition-0_2" alt="Cliente" src={this.props.image} />
                </div>
            </div>
        );
    }
}

export default Cliente;


// WEBPACK FOOTER //
// ./src/subcomponents/Cliente.js